<template>
    <div
      class="IP-role"
      :style="{width: screenWidth + 'px', height: screenHeight + 'px'}"
    >
        <!-- <div
            v-show="!iframeShown"
            class="loading"
        ></div> -->
        <iframe
          ref="iframeRef"
          name="user-buy"
          class="iframe"
          :src="embeddedLink"
        ></iframe>
    </div>
</template>
  
<script>
import { mapGetters } from 'vuex';
import getCommon from "@/components/mixins/resourcesArea/getResourcesCommon";
export default {
  mixins: [getCommon],
  data () {
    return {
        embeddedLink: '',
        iframeRef: null,
        screenWidth: 0,
        screenHeight: 0,
        recentCharater: null
    }
  },
  computed: {
    ...mapGetters([
        'iframeShown',
        'ipBuyId',
        'ipRole',
        'role'
    ])
  },
  created () {
    
  },
  methods: {
    // ...mapMutations({
    //   setCharacterStauts: "characterContent/setCharacterStauts",
    // }),
    setEmbeddedLink () {
        console.log(this.ipBuyId);
        const linkOrigin = location.origin;
        const linkPath = '/chatip/buyip';
        this.embeddedLink = `${linkOrigin}${linkPath}?ipBuyId=${this.ipBuyId}`;
        console.log(this.embeddedLink)
    },
    close () {
        this.$store.commit('set_iframeShown', false);
    },

    async onPostMessage (e) {
        console.log(`Turbo ~ onPostMessage ~ e.data:`, e.data);
        if (e.data.dialogOpen) {
          this.iframeShown = true;
          return;
        }

        // pay finished
        if (e.data.payment) {
          if (e.data.payment.code === 200 && e.data.payment.body) {
            console.log(`Turbo ~ onPostMessage ~ e.data`, e.data);
            this.close();
          
            this.recentCharater = this.ipRole;
            this.role.characterId = this.ipRole.id;
            this.slidAddSprites(this.role);
            this.materialPushAnalysis({
              type: "character",
              id: this.role.id,
              name: this.role.name,
            });
            // this.setCharacterStauts({ state: false });
            this.$bus.emit('refreshIP');
          }
        }
        
    
        if (e.data.clickClose) {
          this.close();
          return;
        }
    },

    bindEvents () {
      window.addEventListener('message', this.onPostMessage);
    },
    unbindEvents () {
      window.removeEventListener('message', this.onPostMessage);
    },
  },
  mounted () {
    this.bindEvents();
    this.setEmbeddedLink();
    this.screenWidth = document.body.clientWidth
    console.log(`Turbo ~ created ~ this.screenWidth:`, this.screenWidth);
    this.screenHeight = document.body.clientHeight;
    console.log(`Turbo ~ created ~ this.screenHeight:`, this.screenHeight);
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.screenHeight = document.body.clientHeight;
      })();
    };
  },
  beforeMount () {
    this.unbindEvents();
  }
}
</script>

<style lang="scss" scoped>
.IP-role {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 30;
  width: 100%;
  height: 100%;
//   background-color: transparent;
  .iframe {
    width: 100%;
    height: 100%;
    border: none;
    // background-color: transparent;
  }
//   .loading {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     width: 50px;
//     height: 120px;
//     background-size: 100% 100%;
//     background-repeat: no-repeat;
//   }
}
</style>
  


// WEBPACK FOOTER //
// src/components/emodal/IPRolePay/IPRolePayModal.vue